import { patchPhotographerPhoto } from 'apiCalls/PhotographerRequests'
import { SpinLoader } from 'components/Loader/SpinLoader'
import Compressor from 'compressorjs'
import { useAppContext } from 'context/AppContext'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import styled, { css } from 'styled-components'

function ImageUpload(props) {
  const { icon, width, uploadedImage, locationPage = 'false' } = props
  const [uploadedFile, setUploadedFile] = useState()
  const [context, dispatch] = useAppContext()
  const imageRef = useRef(null)
  const [loading, setLoading] = useState(false)

  const onChange = (e) => {
    if (props.imageName === 'faviconImage') {
      new Compressor(e.target.files[0], {
        width: 76,
        height: 76,
        resize: 'cover',
        success(result) {
          let newFile = new File([result], result.name)
          setUploadedFile(URL.createObjectURL(newFile))
          onSubmit(newFile)
        },
      })
    } else {
      if (e.target.files[0]) {
        new Compressor(e.target.files[0], {
          maxWidth: 2000,
          success(result) {
            let newFile = new File([result], result.name)
            setUploadedFile(URL.createObjectURL(newFile))
            onSubmit(newFile)
          },
        })
      } else {
        dispatch({
          type: 'setAlertType',
          alertType: 'error',
        })
        dispatch({
          type: 'setAlertText',
          alertText: ['Image format is not supported '],
        })
      }
    }
  }

  async function onSubmit(file) {
    setLoading(true)
    const formData = new FormData()
    let name = props.imageName
    formData.append(name, file)
    const response = await patchPhotographerPhoto(formData, context.photographer.identifier, context.token)
    if (response.status === 200) {
      props.uploaded(true)
      dispatch({
        type: 'setPhotographer',
        photographer: response.data,
      })
      dispatch({
        type: 'setAlertType',
        alertType: 'success',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['Changes were successfully saved'],
      })
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['Something went wrong, could not delete photo'],
      })
      throw new Error(response.data)
    }
    setLoading(false)
  }

  const handleImageButton = () => {
    imageRef.current.click()
  }

  return (
    <React.Fragment>
      <Col>
        <Input
          ref={imageRef}
          type="file"
          id="customFile"
          className="form-control"
          data-testid={props.testid}
          style={{ display: 'none', fontSize: '16px' }}
          onChange={onChange}
          accept="image/png, image/jpeg, image/jpg"
        />
        {!loading ? (
          <ImgWrapper width={width} $round={props.round ? true : false} $header={props.header ? true : false}>
            <Img uploadedImage={uploadedImage} src={uploadedFile || props.image} alt="image upload" />
          </ImgWrapper>
        ) : (
          <AvtarLoader>
            <SpinLoader size={20} />{' '}
          </AvtarLoader>
        )}
        {icon ? (
          <>
            {!loading && locationPage === 'profile' && (
              <UploadProfileIcon src={icon} alt="icon" onClick={handleImageButton} />
            )}
          </>
        ) : (
          <ButtonWrapper>
            <Button onClick={handleImageButton}>Select Image</Button>
          </ButtonWrapper>
        )}
      </Col>
    </React.Fragment>
  )
}

export default ImageUpload

ImageUpload.propTypes = {
  imageName: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  round: PropTypes.bool,
}

const Col = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  position: relative;
  width: 100%;
  min-height: 1px;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 24px;
`
const ButtonWrapper = styled.div`
  display: block;
  text-align: center;
  @media (max-width: 700px) {
    width: 100%;
  }
`

const Button = styled.button`
  border: 1px solid transparent;
  letter-spacing: 0.025em;
  font-size: 12px;
  width: 120px;
  background-color: var(--black);
  padding: 0.25rem 0.75rem;
  :hover {
    opacity: 0.8;
  }
`
const Input = styled.input``

const ImgWrapper = styled.div`
  display: flex;
  align-self: center;
  color: #fff;
  background-color: #adb5bd;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  overflow: hidden;
  width: 150px;
  height: 150px;
  border: 5px solid #fff;
  border-radius: ${(props) => (props.$round ? '50%!important;' : '0.375rem')};
  ${(props) =>
    props.$header &&
    css`
      width: 500px;
    `}
  @media (max-width: 700px) {
    width: ${({ width }) => (width ? width : '')};
  }
`
const AvtarLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const Img = styled.img`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
  object-fit: cover;
`
const UploadProfileIcon = styled.img`
  position: absolute;
  width: 54px;
  height: 54px;
  cursor: pointer;
  top: 100px;
  left: 100px;
`
